let audioContext = null;
let analyser = null;
let source = null;
let dataArray = null;

export function setupAudioContext(audioEl) {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
    analyser = audioContext.createAnalyser();
    analyser.fftSize = 256;
    dataArray = new Uint8Array(analyser.frequencyBinCount);
  }

  if (!source) {
    try {
      source = audioContext.createMediaElementSource(audioEl);
      source.connect(analyser);
      analyser.connect(audioContext.destination);
    } catch (err) {
      console.warn('MediaElementSource already created:', err.message);
    }
  }
  return { audioContext, analyser, dataArray };
}

// Cleanup function to disconnect and reset the source
export function cleanupAudioContext() {
  try {
    if (source) {
      source.disconnect();
      source = null;
    }
    if (analyser) {
      analyser.disconnect();
      analyser = null;
    }
    if (audioContext) {
      audioContext.close();
      audioContext = null;
    }
    dataArray = null;
  } catch (err) {
    console.warn('Error cleaning up audio context:', err);
  }
}
